import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { Box, Typography } from "@mui/material";

type FeedbackProps = {
  total: number | undefined;
  positive: number | undefined;
  negative: number | undefined;
};

const calculatePercentage = (total: number, value: number) => {
  try {
    const percentage = Number(((value / total) * 100).toFixed(2));

    if (isNaN(percentage)) {
      return 0;
    }
    return percentage;
  } catch {
    return 0;
  }
};

export const Feedback = (props: FeedbackProps) => {
  const positivePercentage = calculatePercentage(
    props.total as number,
    props.positive as number,
  );
  const negativePercentage =
    props.positive || props.negative ? 100 - positivePercentage : 0;

  const positiveColor = `linear-gradient(to top,  #1DA5AB 0%,#1DA5AB ${positivePercentage}%,#EEEDF3 ${positivePercentage}%,#EEEDF3 100%);`;

  const negativeColor = `linear-gradient(to top, #EE4242 0%, #EE4242 ${negativePercentage}%,#EEEDF3 ${negativePercentage}%,#EEEDF3 100%);`;

  return (
    <Box
      sx={{
        borderRadius: "30px",
        background: (theme) => theme.palette.common.white,
        paddingX: "1.5rem",
        flexGrow: 1,
        alignItems: "center",
        display: "flex",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
            flex: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "48px",
              fontWeight: "700",
              lineHeight: "26px",
              color: "#161447",
            }}
          >
            {props.total}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "26px",
            }}
          >
            Feedbacks
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "3rem",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
            }}
          >
            <Box
              sx={{
                height: "20rem",
                width: "180px",
                background: positiveColor,
                borderRadius: 6,
                display: "flex",
              }}
            />
            <SVGInternalIcon
              icon="like2XIcon"
              sx={{
                height: 50,
                width: 50,
                position: "absolute",
                bottom: 20,
                left: "50%",
                transform: "translateX(-50%)",
                "& .like-icon": {
                  fill: "white",
                },
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: 20,
                left: "50%",
                transform: "translateX(-50%)",
                "& .cls-1": {
                  fill: "white",
                },
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "26px",
                }}
              >
                {props.positive} resp
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "26px",
                }}
              >
                {positivePercentage}%
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
            }}
          >
            <Box
              sx={{
                height: "20rem",
                width: "180px",
                background: negativeColor,
                borderRadius: 6,
                display: "flex",
              }}
            />
            <SVGInternalIcon
              icon="dislike2XIcon"
              sx={{
                height: 50,
                width: 50,
                position: "absolute",
                bottom: 20,
                left: "50%",
                transform: "translateX(-50%)",
                "& .dislike-icon": {
                  fill: "white",
                },
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: 20,
                left: "50%",
                transform: "translateX(-50%)",
                "& .cls-1": {
                  fill: "white",
                },
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "26px",
                }}
              >
                {props.negative} resp
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "26px",
                }}
              >
                {negativePercentage}%
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
